const cookieConsentConfig = {
	guiOptions: {
		consentModal: {
			layout: 'bar inline',
			position: 'bottom',
		},
		preferencesModal: {
			layout: 'box',
		},
	},

	categories: {
		necessary: {
			readOnly: true,
			enabled: true,
		},
		analytics: {
			enabled: true,
			services: {
				ga: {
					label: 'Google Analytics',
					cookies: [
						{
							name: /^(_ga|_gid)/
						}
					]
				},
			}
		},
		functionality: {
			enabled: true,
		},
	},

	language: {
		default: 'hu',

		translations: {
			hu: {
				consentModal: {
					title: "Cookie adatkezelés",
					description: 'Annak érdekében, hogy a weboldalunk hatékonyabban üzemeljen, sütiket használunk.<br> Az oldalunk alapvető cookie-kat (továbbiakban: sütiket) alkalmaz annak érdekében, hogy biztosítsa megfelelő működését. A sütik olyan kisméretű adatfájlok, amelyek a weboldalon keresztül a weboldal használatával kerülnek a számítógépedre úgy, hogy azokat az internetes böngésző menti le és tárolja el.',
					acceptAllBtn: 'Elfogadom',
					acceptNecessaryBtn: 'Elutasítom',
					showPreferencesBtn: 'Beállítások',
					closeIconLabel: 'Elutasítás és bezárás',
					footer: `
					  <a href="/felhasznalasifeltetelek" target="_blank">Adatkezelési tájékoztató és cookie adatkezelés</a>
                  	`,
				},
				preferencesModal: {
					title: 'Cookie beállítások',
					acceptAllBtn: 'Összes elfogadása',
					acceptNecessaryBtn: 'Összes elutasítás',
					savePreferencesBtn: 'Beállítások mentése',
					sections: [
						{
							title: 'Cookie adatkezelés',
							description: 'Az oldalunk alapvető cookie-kat (továbbiakban: sütiket) alkalmaz annak érdekében, hogy biztosítsa megfelelő működését. A sütik olyan kisméretű adatfájlok, amelyek a weboldalon keresztül, a weboldal használatával kerülnek a számítógépedre úgy, hogy azokat az internetes böngésződ menti le és tárolja el.',
						},
						{
							title: 'A működéshez szükséges sütik',
							description: 'Az oldal működéséhez szükséges sütik.',
							linkedCategory: 'necessary',
							cookieTable: {
								headers: {
									name: 'Cookie',
									domain: 'Domain',
									exp: 'Lejárat',
								},
								body: [
									{
										name: String(import.meta.env.VITE_SESSION_PREFIX).toLowerCase().replaceAll(' ', '_')+'_session',
										domain: '.'+ import.meta.env.VITE_MAIN_DOMAIN,
										exp: '1 nap',
									},
									{
										name: 'XSRF-TOKEN',
										domain: '.'+ import.meta.env.VITE_MAIN_DOMAIN,
										exp: '1 nap',
									},
								],
							},
						},
						{
							title: 'Analitikai sütik',
							description: 'Az adatok névtelen formában való gyűjtésén és jelentésén keresztül analitikai sütik segítenek olyan információk elérésében, hogyan lépnek interakcióba a látogatók a weboldallal.',
							linkedCategory: 'analytics',
						},
						{
							title: 'Funkcionális sütik',
							description: 'Ezek azok a sütik, amelyek a felhasználói élményt növelik az oldalon.',
							linkedCategory: 'functionality',
						},
						{
							title: 'Egyéb információ',
							description: 'Bármilyen kérdése merülne fel, kérem olvassa el a Cookie adatkezelési tájékoztatónkat vagy keresse Ügyfélszolgálatunkat! <a class="cc__link" href="/cookie-adatkezeles" target="_blank">Cookie adatkezelés</a> | <a href="/kapcsolat" target="_blank">Kapcsolat</a>',
						},
					],
				},
			},
		},
	},
};

export default cookieConsentConfig;
